var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedInWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6557 0.314453H1.1685C0.522423 0.314453 0 0.824511 0 1.45513V14.9979C0 15.6286 0.522423 16.1417 1.1685 16.1417H14.6557C15.3017 16.1417 15.8272 15.6286 15.8272 15.001V1.45513C15.8272 0.824511 15.3017 0.314453 14.6557 0.314453ZM4.69562 13.8016H2.34627V6.24658H4.69562V13.8016ZM3.52094 5.21719C2.76668 5.21719 2.1577 4.60821 2.1577 3.85704C2.1577 3.10586 2.76668 2.49688 3.52094 2.49688C4.27212 2.49688 4.8811 3.10586 4.8811 3.85704C4.8811 4.60512 4.27212 5.21719 3.52094 5.21719ZM13.4872 13.8016H11.1409V10.1292C11.1409 9.25438 11.1254 8.12607 9.91985 8.12607C8.6988 8.12607 8.51333 9.08127 8.51333 10.0674V13.8016H6.17015V6.24658H8.42059V7.27906H8.4515C8.76372 6.68554 9.53035 6.05801 10.671 6.05801C13.0482 6.05801 13.4872 7.62219 13.4872 9.65624V13.8016Z",
    fill: "url(#paint0_linear_314_1891)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_314_1891",
    x1: 7.91362,
    y1: 0.314453,
    x2: 7.91362,
    y2: 16.1417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInWhite);
export default __webpack_public_path__ + "static/media/linked-in-white.564b95f4791fb32f5607f951ca58b15a.svg";
export { ForwardRef as ReactComponent };